export default {
  submitAnswers(surveyIdentifier, answers, anonymous = false) {
    return this.put(`/survey/${surveyIdentifier}/answers`, { answers, anonymous })
      .then((responseData) => responseData);
  },
  getRandomAnswers(surveyIdentifier) {
    const url = `/survey/${surveyIdentifier}/random-answers`;

    return this.get(url);
  },
  getUserAnswers(surveyIdentifier, submissionToken = null) {
    let url = `/survey/${surveyIdentifier}/answers`;

    if (submissionToken) {
      url = this.addQueryParams(url, { submissionToken });
    }

    console.log('url', url, 'submissionToken', submissionToken);

    return this.get(url);
  },
  getSurvey(surveyIdentifier) {
    return this.get(`/survey/${surveyIdentifier}`)
      .then((responseData) => responseData);
  },
};
